import { render, staticRenderFns } from "./subPage2.vue?vue&type=template&id=40ab72dd&scoped=true&"
import script from "./subPage2.vue?vue&type=script&lang=js&"
export * from "./subPage2.vue?vue&type=script&lang=js&"
import style0 from "./subPage2.vue?vue&type=style&index=0&id=40ab72dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab72dd",
  null
  
)

export default component.exports